import FarmingPool from "components/FarmingPool/FarmingPool";
import Pool from "components/Pool/Pool";
import { farmingPools } from "eth/contracts/contracts";
import { observer } from "mobx-react";
import React, { useState } from "react";
import VaultStore from "stores/VaultStore";
import "./Pools.scss";

function Pools() {
  const { pools } = VaultStore;
  const [selection, setSelection] = useState(0);

  const selections = {
    0: pools.map((pool) => <Pool key={`pool-${pool.poolId}`} pool={pool} />),
    1: <FarmingPool pool={farmingPools[0]} />,
    2: <FarmingPool pool={farmingPools[1]} />,
  };

  return (
    <div className="pools">
      <div className={`item-header clickable vault ${selection === 0 && "selected"}`} onClick={() => setSelection(0)}>
        VAULT
      </div>
      <div className={`item-header clickable ram ${selection === 1 && "selected"}`} onClick={() => setSelection(1)}>
        RAM POOL
      </div>
      <div className={`item-header clickable ygy ${selection === 2 && "selected"}`} onClick={() => setSelection(2)}>
        YGY POOL
      </div>
      {selections[selection]}
    </div>
  );
}

export default observer(Pools);
